export default "__VITE_ASSET__DLYGO62w__"